import * as z from "zod";

export const regionSchema = z.string();

export const regionsListBodySchema = z.array(regionSchema);

export type RegionsListBody = z.infer<typeof regionsListBodySchema>;
